import React from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import "./Recharge.css";

const Recharge = () => {
  return (
    <section className='recharge-section'>
      <Container>
        <Row className='justify-content-center'>
          <Col md={6} >
            <div className='recharge_box'>
              <div className='recharge_card'>
                <h5 className='title'>Recharge or pay in seconds,<br />
                  <span className='subtitle'> anytime you need.</span></h5>
                  <img src='./assets/images/home/recharge/pay-later.png' alt='wallet_img' className='image' />
                
              </div>
            </div>
          </Col>

          <Col md={6}>
            <div className='recharge_box'>
              <div className='recharge_card'>
                <h5 className='title'>Recharge or pay in seconds,<br />
                  <span className='subtitle'> anytime you need.</span></h5>
                  <img src='./assets/images/home/recharge/pay-later.png' alt='wallet_img' className='image' />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default Recharge;